import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DeleteOutlined, DownloadOutlined, EditOutlined, FileMarkdownOutlined, ReloadOutlined } from '@ant-design/icons';
import { Table, Modal, Tooltip, Divider, Space, Button, Skeleton } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _ from 'lodash';
import qs from 'qs';
import TextTruncate from 'react-text-truncate';
import { checkPermission } from '@/utils/permission';
import { cleanObject, downloadFromLink, renderBooleanIcon, stripHtml } from '@/utils/helpers';
import HtmlParser from 'react-html-parser';

import { getListProcedure, getSpecificProcedure, removeProcedure } from '@/redux/actions/procedureActions';
import ProcedureForm from './ProcedureForm';
import ProcedureDetail from './ProcedureDetail';

const { confirm } = Modal;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/procedures',
        breadcrumbName: 'Danh sách thủ thuật',
    },
]

class ProcedureList extends Component {
    state = {
        isLoading: false,
        selectedRowKeys: [],
        isOpenForm: false,
        currentItem: null,
        currentData: null,
        isOpenDetail: false
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.loadData(query);
        }
    }

    loadData = (query) => {
        this.setState({ isLoading: true });
        this.props.getListProcedure(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }

        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({ isOpenForm: isOpenForm, currentItem: currentItem });
    }

    onEdit(id) {
        this.props.getSpecificProcedure(id).then(res => {
            console.log(res);
            this.toggleOpenForm(true, res);
        })
    }

    onRemove() {
        this.props.removeProcedure(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: []
            });
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
        })
    }
    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá những bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeProcedure(id).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    onDetail(id) {
        this.setState({ current_id: id })
        this.props.getSpecificProcedure(id).then(res => {
            console.log(res);
            this.toggleOpenDetail(true, res);
        })
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentData: data });
    }

    onDownload(url) {
        setTimeout(() => {
            const response = {
                file: url,
            };
            downloadFromLink(response.file);
        }, 100);
    }

    render() {
        var { procedureList, pagination } = this.props;
        var { isLoading, selectedRowKeys, isOpenForm, currentItem, currentData, isOpenDetail, current_id } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;

        var query = qs.parse(this.props.location.search.slice(1));

        const allowCreate = checkPermission('procedures', 'create');
        const allowEdit = checkPermission('procedures', 'update');
        const allowRemove = checkPermission('procedures', 'remove');
        const allowDetail = checkPermission('procedures', 'detail');

        const columns = [

            // {
            //     title: 'Tên thủ thuật',
            //     dataIndex: 'name',
            //     key: 'name',
            //     width: '300px',
            //     render: (text, record) => {
            //         if (allowDetail) {
            //             return (
            //                 <div className='color-primary item-action-btn' onClick={() => this.onDetail(record.id)}>
            //                     {text}
            //                 </div>
            //             )
            //         } else {
            //             return (<>{text}</>)
            //         }
            //     }
            // },
            {
                title: 'Tên thủ thuật',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => {
                    if (allowDetail) {
                        return (
                            <span
                                // className="color-primary item-action-btn col-procedure-name"
                                className="color-primary item-action-btn"
                                onClick={() => this.onDetail(record.id)}
                            >
                                {text}
                            </span>
                        );
                    }
                    return <span className="col-procedure-name">{text}</span>;
                }
            },
            {
                title: 'Đơn vị tính',
                dataIndex: ['unit', 'name'], // nếu unit là object { name: "..." }
                key: 'unit',
                align: 'center',
                width: 100,
                render: (text, record) => record?.unit?.name || '-'
            },
            {
                title: 'Thời gian thực hiện',
                dataIndex: 'execution_time',
                key: 'execution_time',
                align: 'center',
                width: 150,
                render: (text) => text ? `${text} phút` : '-'
            },
            {
                title: 'Điểm đánh giá',
                dataIndex: 'pain_score',
                key: 'pain_score',
                align: 'center',
                width: 130,
                render: (text) => text ?? '-'
            },
            // {
            //     title: 'Mã thủ thuật',
            //     dataIndex: 'code',
            //     key: 'code',
            //     align: 'center',
            //     width: 150,
            // },

            // {
            //     title: 'Mô tả',
            //     dataIndex: 'description',
            //     key: 'description',
            //     width: '400px',
            //     render: (text, record) => {
            //         return (
            //             <div style={{ wordBreak: "break-word" }}>
            //                 {/* <Tooltip title={HtmlParser(text)} placement="topLeft">
            //                     <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
            //                 </Tooltip> */}
            //                 {text}
            //             </div>
            //         )
            //     }
            // },
            // {
            //     title: 'Tài liệu mẫu',
            //     dataIndex: 'documents',
            //     key: 'documents',
            //     width: 200, // số thay vì '200px'
            //     render: (docs, record) => {
            //         // Chuẩn hoá dữ liệu: chấp nhận array hoặc JSON string
            //         let items = [];
            //         if (Array.isArray(docs)) {
            //             items = docs;
            //         } else if (typeof docs === 'string' && docs.trim()) {
            //             try {
            //                 items = JSON.parse(docs);
            //             } catch (e) {
            //                 items = [];
            //             }
            //         }

            //         if (!items.length) return '—';

            //         return (
            //             <Space direction="vertical" size={4} style={{ width: '100%', wordBreak: 'break-word' }}>
            //                 <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            //                     {items.map((item, idx) => (
            //                         <li key={item.id || item.name || idx} style={{ display: 'flex', alignItems: 'center' }}>
            //                             <FileMarkdownOutlined style={{ marginRight: 6 }} />
            //                             <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            //                                 {item.name || 'Tệp không tên'}
            //                             </span>
            //                             <Button
            //                                 type="link"
            //                                 size="small"
            //                                 icon={<DownloadOutlined />}
            //                                 style={{ color: 'blue' }}
            //                                 onClick={(e) => {
            //                                     e.stopPropagation(); // tránh trigger row click
            //                                     this.onDownload(item.data || item.url || item.path);
            //                                 }}
            //                                 aria-label={`Tải xuống ${item.name || 'tệp'}`}
            //                             />
            //                         </li>
            //                     ))}
            //                 </ul>
            //             </Space>
            //         );
            //     }
            // },

            // {
            //     title: 'Ghi chú',
            //     dataIndex: 'note',
            //     key: 'note',
            //     width: '200px',
            //     render: (text, record) => {
            //         return (
            //             <div style={{ wordBreak: "break-word" }}>
            //                 <Tooltip title={HtmlParser(text)} placement="topLeft">
            //                     <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
            //                 </Tooltip>
            //             </div>
            //         )
            //     }
            // },

            {
                title: 'Trạng thái',
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                width: 90,
                render: (text, record) => {
                    return (<>{renderBooleanIcon(text)}</>)
                }
            },
            {
                title: '#',
                width: '75px',
                align: 'center',
                render: (text, record) => (
                    <div>
                        {
                            allowEdit ? (
                                <>
                                    <EditOutlined className='color-primary item-action-btn' onClick={() => this.onEdit(record.id)} />
                                    <Divider type='vertical' />
                                </>
                            ) : null
                        }
                        {
                            allowRemove ? (
                                <DeleteOutlined style={{ color: 'red', cursor: 'pointer' }} onClick={() => this.openAlert([record.id])} />
                            ) : null
                        }
                    </div>
                )
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Danh sách thủ thuật" />
                <div>
                    <TableActionBar
                        isShowAddButton={allowCreate}
                        isShowDeleteButton={allowRemove}
                        onAdd={() => this.toggleOpenForm(true)}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={false}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                    >
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''
                        }
                    </TableActionBar>
                </div>
                {/* <Table
                    rowKey="id"
                    size="small"
                    tableLayout='auto'
                    dataSource={procedureList ?? []}
                    columns={columns}
                    loading={isLoading}
                    rowSelection={rowSelection}
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`
                    }}
                    onChange={(pagination, filters, sorter) => this.onChangeTable(pagination, sorter)}
                    scroll={{
                        x: 'max-content'
                    }}
                /> */}

                {
                    procedureList && procedureList.length ? (
                        <Table
                            rowKey="id"
                            size="small"
                            dataSource={procedureList ?? []}
                            columns={columns}
                            loading={isLoading}
                            rowSelection={rowSelection}
                            defaultExpandAllRows={true}
                            pagination={{
                                pageSize: pagination.perPage,
                                current: pagination.currentPage,
                                total: pagination.total,
                                showTotal: total => `Tổng ${total} bản ghi`
                            }}
                            onChange={(pagination, filters, sorter) => this.onChangeTable(pagination, sorter)}
                            scroll={{
                                x: 'max-content'
                            }}
                        />
                    ) : (
                        <Skeleton active />
                    )
                }

                <ProcedureForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    reloadData={() => this.loadData(query)}
                    onCancel={() => this.toggleOpenForm(false)}
                />
                <ProcedureDetail
                    visible={isOpenDetail}
                    currentItem={currentData}
                    reloadData={() => {
                        this.onDetail(current_id);
                        this.loadData(query);
                    }}
                    onCancel={() => this.toggleOpenDetail(false)}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        procedureList: state.procedureReducer.procedureList,
        pagination: state.procedureReducer.pagination,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListProcedure: (filter) => dispatch(getListProcedure(filter)),
        getSpecificProcedure: (id) => dispatch(getSpecificProcedure(id)),
        removeProcedure: (ids) => dispatch(removeProcedure(ids))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProcedureList);
